export const maxCasePdfReportSizeInMegabytes = 60;
